import type { ProgressTree } from '@localagent/sdk';

export interface WakeLabelProps {
  run: ProgressTree;
  testId: string;
  className?: string;
}

const TASK_CHECK_SENDER = 'task-check';

// (sessions ADR-1e992)
export function WakeLabel({ run, testId, className = '' }: WakeLabelProps) {
  if (run.trigger !== 'background' && run.trigger !== 'agent_message') return null;
  const sources = run.wakeSources ?? [];
  if (run.trigger === 'agent_message' && sources.some((s) => s.id === TASK_CHECK_SENDER)) {
    const others = sources.filter((s) => s.id !== TASK_CHECK_SENDER).map((s) => s.label);
    const text = sources.find((s) => s.id === TASK_CHECK_SENDER)?.text;
    return (
      <div
        data-testid={testId}
        data-trigger="task_check"
        className={`flex flex-col gap-1 rounded-md border border-primary/30 bg-primary/5 px-2.5 py-2 ${className}`}
      >
        <p className="inline-flex items-center gap-1.5 text-micro font-semibold uppercase tracking-wide text-primary">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
            <path d="M20 6L9 17l-5-5" />
          </svg>
          Task check
          {others.length > 0 ? <span className="font-normal normal-case">· also from {others.join(', ')}</span> : null}
        </p>
        {text ? (
          <p data-testid={`${testId}-text`} className="whitespace-pre-line text-caption text-foreground">
            {text}
          </p>
        ) : null}
      </div>
    );
  }
  const names = sources.map((s) => s.label);
  return (
    <p
      data-testid={testId}
      data-trigger={run.trigger}
      className={`rounded bg-info-subtle px-2 py-1.5 text-micro text-info-text ${className}`}
    >
      {run.trigger === 'agent_message' ? 'Message from another agent' : 'Follow-up from background work'}
      {names.length > 0 ? `: ${names.join(', ')}` : ''}
    </p>
  );
}
